import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'
import { connect } from "react-redux";
import Alert from '../common/modal/Alert';
import Loading from '../common/modal/Loading';
import FormTemplate from "../common/form/FormTemplate";
import LoginTop from "../top/LoginTop";
import axios from "axios";
import configData from "../../config/config.json";
import Footer from '../bottom/Footer'
import { trimUserFields, validatePassword } from "../common/function/userValidation.js";
import { LOADING_STATUES, ALERT_TYPES, PASSWORD_RULES } from "../constants/constants";
import translations from "../../config/translation/login_translations.json"

const mapStateToProps = (state) => {
	return {
		language: state.languageReducer ? state.languageReducer : 'ENGLISH'
	};
}

class PasswordResetBig extends React.Component {
	state = {
		password: "",
		passwordConfirm: "",
		showAlert: false,
		alertMessage: "",
		alertType: ALERT_TYPES.OK,
		loadingStatus: "",
		errors: {},
		redirectToLogin: false
	  }

	showLoading = () => {
		if (this.state.loadingStatus === "") {
			this.setState({
				loadingStatus: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	handleChange = (event) => {
		event.preventDefault();
	
		let value = event.target.value;
		this.setState({
		   [event.target.id]: value,
		   errors: {}
		})
	}
	
	validateAndSubmit = () => {
		// need to validate same passwords

		let errors = validatePassword(this.state);
		if (errors && Object.keys(errors).length > 0) {
			this.setState({errors});
			return;
		}

		if (this.showLoading() === true) {
			let { loadingStatus, alertType, errors, alertMessage, redirectToLogin, showAlert, passwordConfirm, ...request } = this.state; // remove UI only fields before submitting
			var ticket = {ticket: this.props.match.params.ticket};
			request = {...request, ...ticket};
			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "auth/resetPassword", request, { withCredentials: true })
				.then((response) => {
					this.setState({status: "", redirectToLogin: true}, this.showAlert("Password updated.  You may now log in.")); 
				}, (error) => {
					this.setState({ alertType: ALERT_TYPES.WARNING, status: ""}, this.showAlert(error.response.data.message, ALERT_TYPES.WARNING));
				});
		}
	}

	handleSubmit = (event) => {
		event.preventDefault();

		const trimmedUserFields = trimUserFields(this.state);
		this.setState({ ...trimmedUserFields }, function () {
			this.validateAndSubmit();
		});
	}
	
	handleCancel = (event) => {
		event.preventDefault();
		this.props.history.push('/login');
	}

	showAlert = (alertMessage, alertType=ALERT_TYPES.OK) => {
		this.setState({
		  showAlert: true,
		  alertType,
		  alertMessage
		})
	  }
	
	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertType: ALERT_TYPES.OK,
			alertMessage: '',
			password: '',
			passwordConfirm: ''
		});

		if (this.state.redirectToLogin) {
			this.props.history.push('/login');
		}  else {
		 	window.location.reload();
		}
	}

	render() {
		let formGroupRows = [
			{
				formGroups: [{ id: 'password', label: translations[this.props.language].new_password, fieldType: 'password', autoComplete: 'new-password', value: this.state.password, required: true,  primaryCriteria: true, error: this.state.errors['password'], hint: translations[this.props.language].password_hint, passwordRules: PASSWORD_RULES  } ]
			},
			{
				formGroups: [ { id: 'passwordConfirm', label: translations[this.props.language].confirm_password, fieldType: 'password', autoComplete: 'new-password', value: this.state.passwordConfirm, required: true, primaryCriteria: true,  error: this.state.errors['passwordConfirm']  }]
			}
		]

		const formProps = {
			componentName: "PasswordReset",
			pageHeading: translations[this.props.language].create_new_password,
			onChange: this.handleChange,
			onSubmit: this.handleSubmit,
			onCancel: this.handleCancel,
			formGroupRows: formGroupRows,
			formOnly: true
		}

		return (
			<>
                <LoginTop />
				<section className="cn container-fluid" style={{background: '#145A7B' }}>
				<div style={{background: 'white', paddingBottom: 10, paddingLeft: 10, paddingRight: 10}}>
					<Container fluid="true" >
						<Row>
						<Col>
							<FormTemplate {...formProps} />
						</Col>
						</Row>
					</Container>
				</div>
				</section>
				<Footer />
				<Loading loadingIndicator={this.state.status === LOADING_STATUES.LOADING} />
				<Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} type={this.state.alertType}/>
			</>
        )
    }
}

export default connect(mapStateToProps)(PasswordResetBig);